module.exports = __webpack_public_path__ + "static/media/image.2fbad715.svg";